import * as React from "react";
const SvgScales01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 3a1 1 0 1 1 2 0v3.82l4.836-.806L17.99 6a1 1 0 0 1 .878.504l3.578 6.262c.142.248.268.463.358.699q.111.292.16.6c.025.16.03.319.033.488L23 14.8v.2a5 5 0 0 1-10 0v-.2c0-.075 0-.161.003-.247a3.5 3.5 0 0 1 .033-.488q.048-.308.16-.6c.09-.236.216-.45.358-.7l2.533-4.433L7.58 9.75l2.866 5.016c.142.248.268.463.358.699q.111.292.16.6c.025.16.03.319.033.488L11 16.8v.2a5 5 0 0 1-10 0v-.2c0-.075 0-.161.003-.247.002-.17.008-.329.033-.488q.048-.308.16-.6c.09-.236.216-.45.358-.7l3.578-6.261.06-.094a1 1 0 0 1 .644-.396L11 7.152zM3 17a3 3 0 1 0 6 0zm12-2a3 3 0 1 0 6 0zM3.723 15h4.554L6 11.015zm12-2h4.554L18 9.015z"
}));
export default SvgScales01;
//# sourceMappingURL=Scales01.js.map